// extracted by mini-css-extract-plugin
export default {"layout":"Layout-module--layout--0fa7d","header":"Layout-module--header--3d598","main":"Layout-module--main--9156d","mainSpaced":"Layout-module--mainSpaced--8359d"};